import {
  B_AND_I_LINK,
  LOAN_LEVEL_DATA_LINK,
  NEW_ISSUE_PIPELINE_LINK,
  PORTFOLIO_MONITOR,
  slickModuleKeys,
  STRAT_MARKET_LINK,
  TRACE_URL,
} from './constants';
import dealroadshowIcon from '@/finsight/ui/components/staticPages/Company/OurSolutions/assets/icons/dealroadshow.inline.svg';
import finsightIcon from '@/finsight/ui/components/staticPages/Company/OurSolutions/assets/icons/analytics.inline.svg';

import styles from './ourSolutions.scss';

const getSlickModuleConfig = (actions) => ([
  {
    key: slickModuleKeys.DRS_LIVE_VIDEO,
    title: 'DRS Live Video',
    content: `Deal Roadshow now offers live video conferencing within your roadshow.
             Consolidate your workflow and leverage the power of video conferencing in our secure viewer,
             with unrivaled analytics backed by fanatical 24x7 support.`,
    headClass: styles.blueHead,
    buttonContent: 'Book demo',
    icon: dealroadshowIcon,
    onLinkClick: actions[slickModuleKeys.DRS_LIVE_VIDEO],
    product: 'Deal Roadshow',
  },
  {
    key: slickModuleKeys.API,
    title: 'API',
    content: `Access the most accurate and comprehensive new issue pricing data through the FINSIGHT API.
             It covers asset-backed new issues in the United States.
             Contact us today to learn more and request pricing.`,
    headClass: styles.purpleHead,
    buttonContent: 'Contact Us',
    icon: finsightIcon,
    onLinkClick: actions[slickModuleKeys.API],
    product: 'Finsight.com',
  },
  {
    key: slickModuleKeys.BWICS_INVENTORY,
    title: 'BWICS & Inventory',
    content: `Seamlessly explore BWICS & Inventory across the US ABS market.
             Search across actively trading and historical bonds and filter by Sector, Subsector, Dealer and other criteria.
             Export results in a clean and standardized format.`,
    headClass: styles.purpleHead,
    buttonContent: 'Learn more',
    icon: finsightIcon,
    link: B_AND_I_LINK,
    product: 'Finsight.com',
  },
  {
    key: slickModuleKeys.LOAN_LEVEL_DATA,
    title: 'Loan-Level Data',
    content: `A web crawler that automatically tracks and converts from XML to CSV,
              SEC ABS-EE filings posted to EDGAR.
              These filings are posted monthly in the US ABS market and include loan-level performance data.`,
    headClass: styles.purpleHead,
    buttonContent: 'Learn more',
    icon: finsightIcon,
    link: LOAN_LEVEL_DATA_LINK,
    product: 'Finsight.com',
  },
  {
    key: slickModuleKeys.PORTFOLIO_MONITOR,
    title: 'Portfolio Monitor',
    content: `Keep a constant pulse on US ABS secondary activity for your most actionable bonds
              on an organized dashboard that leverages Finsight’s award-winning BWIC, Inventory and TRACE modules.`,
    headClass: styles.purpleHead,
    buttonContent: 'Learn more',
    icon: finsightIcon,
    link: PORTFOLIO_MONITOR,
    product: 'Finsight.com',
  },
  {
    key: slickModuleKeys.STRAT_MAKER,
    title: 'StratMaker',
    content: `A web-based multi-level pivot table of US Auto ABS loan-level performance data.
              It provides instant, consistent and granular insights across
              loan level data of auto ABS issuers with public shelves.`,
    headClass: styles.purpleHead,
    buttonContent: 'Learn more',
    icon: finsightIcon,
    link: STRAT_MARKET_LINK,
    product: 'Finsight.com',
  },
  {
    key: slickModuleKeys.TRACE,
    title: 'TRACE',
    content: 'Seamlessly explore TRACE data across the US ABS market. Search across historical trade details and filter by Sector, Subsector, and other criteria. ',
    headClass: styles.purpleHead,
    buttonContent: 'Learn more',
    icon: finsightIcon,
    link: TRACE_URL,
    product: 'Finsight.com',
  },
  {
    key: slickModuleKeys.ALERTS_15G,
    title: '15-G Alerts',
    content: `A web-crawler that automatically sends email notifications when new SEC 15-G filings are posted to EDGAR.
              It is a leading indicator of new issue launching in the US ABS market.`,
    headClass: styles.purpleHead,
    buttonContent: 'Subscribe here',
    icon: finsightIcon,
    link: NEW_ISSUE_PIPELINE_LINK,
    product: 'Finsight.com',
  },
]);

export default getSlickModuleConfig;
